
    <template>
        <div class="product-grid">
            <div class="product-item" v-for="product in products" :key="product.productCode" @click="showDetailPage(product.productCode)">
                <img :src="product.showImg" :alt="product.productName" class="product-image" />
                <div class="product-info">
                <h3>{{ product.productName }}</h3>
               <!-- <p class="price">{{ product.price }}元</p>
               可以添加其他商品信息，如评分、库存等 -->
                </div>
                <!-- <button @click="addToCart(product)" class="add-to-cart-btn">添加到购物车</button> -->
            </div>
        </div>
    </template>



  <script>
  export default {
    props:{
    productId:String
  },
    mounted(){
      this.getProduct();
    },
    data() {
      return {
        products: [
          
        ],
      };
    },
    methods: {
      showDetailPage(code){
        this.$emit('getBack',code)
      },
      getProduct(){
        this.postRequest('/yl/product/getProduct', {}).then(resp => {
            if (resp) {
                this.products = resp.data;
            }
        });
      }

    },
  };
  </script>
  
  <style scoped>
  .product-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0 20px;
  }
  
  .product-item {
    flex: 0 0 12%; /* 控制每个商品项的宽度，这里设置为24%，可根据需要调整 */
    margin: 20px; /* 商品项之间的间距 */
    text-align: center;
  }
  
  .product-image {
    width: 100%;
    height: auto;
    display: block;
    margin-bottom: 10px; /* 图片与商品信息之间的间距 */
  }
  
  .product-info {
    padding: 10px;
  }
  
  .add-to-cart-btn {
    display: block;
    margin: auto;
    padding: 10px;
    background-color: #4CAF50; /* 按钮背景色 */
    color: white; /* 按钮文字颜色 */
    border: none;
    cursor: pointer;
  }
  
  .add-to-cart-btn:hover {
    background-color: #45a049; /* 鼠标悬停时的背景色 */
  }
  </style>